// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/check-black.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox {
  --main-color: var(--blue);
  --border-color: var(--blue-grey-300);
  --bg-color: var(--grey-100);
  display: flex;
  align-items: center;
  position: relative;
}
.checkbox-yellow {
  --main-color: var(--yellow);
  --border-color: var(--yellow);
  --bg-color: var(--yellow);
}
.checkbox-brown {
  --main-color: var(--brown);
  --border-color: var(--brown);
  --bg-color: var(--brown);
}
.checkbox-red {
  --main-color: var(--red-300);
  --border-color: var(--red-300);
  --bg-color: var(--red-300);
}
.checkbox-orange {
  --main-color: var(--orange-200);
  --border-color: var(--orange-200);
  --bg-color: var(--orange-200);
}
.checkbox-green {
  --main-color: var(--green);
  --border-color: var(--green);
  --bg-color: var(--green);
}
.checkbox-blue {
  --main-color: var(--blue-200);
  --border-color: var(--blue-200);
  --bg-color: var(--blue-200);
}
.checkbox-violet {
  --main-color: var(--violet);
  --border-color: var(--violet);
  --bg-color: var(--violet);
}
.checkbox-grey {
  --main-color: var(--grey-500);
  --border-color: var(--grey-500);
  --bg-color: var(--grey-500);
}
.checkbox-white {
  --main-color: var(--white);
  --bg-color: var(--white);
}
.checkbox-white .checkbox__field:checked + .checkbox__label:before {
  border-color: rgba(var(--blue-grey-300));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.checkbox-black {
  --main-color: var(--black);
  --border-color: var(--black);
  --bg-color: var(--black);
}
.checkbox__field {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.checkbox__field:checked + .checkbox__label:before {
  border-color: rgba(var(--main-color));
  background-color: rgba(var(--main-color));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 11px 9px;
}
.checkbox__field:focus:not(:checked):not(.checkbox__field_custom-color) + .checkbox__label:before {
  border-color: rgba(var(--main-color));
  background-color: rgba(var(--main-color), 0.1);
}
.checkbox__label {
  display: inline-flex;
  align-items: center;
  -webkit-user-select: none;
          user-select: none;
  width: 100%;
  cursor: pointer;
}
.checkbox__label:before {
  content: "";
  box-sizing: border-box;
  display: inline-block;
  width: 1.25rem;
  height: 1.25rem;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid rgba(var(--border-color));
  background-color: rgba(var(--bg-color));
  border-radius: 0.25rem;
  margin-right: 0.5rem;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 50% 50%;
}

.filter__brand-list .checkbox__label {
  text-transform: capitalize;
}

[data-filter=brand] .dropdown_mobile .checkbox__label {
  text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/Checkbox/styles.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,oCAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACE,2BAAA;EACA,6BAAA;EACA,yBAAA;AACJ;AAEE;EACE,0BAAA;EACA,4BAAA;EACA,wBAAA;AAAJ;AAGE;EACE,4BAAA;EACA,8BAAA;EACA,0BAAA;AADJ;AAIE;EACE,+BAAA;EACA,iCAAA;EACA,6BAAA;AAFJ;AAKE;EACE,0BAAA;EACA,4BAAA;EACA,wBAAA;AAHJ;AAME;EACE,6BAAA;EACA,+BAAA;EACA,2BAAA;AAJJ;AAOE;EACE,2BAAA;EACA,6BAAA;EACA,yBAAA;AALJ;AAQE;EACE,6BAAA;EACA,+BAAA;EACA,2BAAA;AANJ;AASE;EACE,0BAAA;EACA,wBAAA;AAPJ;AASI;EACE,wCAAA;EACA,yDAAA;AAPN;AAWE;EACE,0BAAA;EACA,4BAAA;EACA,wBAAA;AATJ;AAYE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;AAVJ;AAYI;EACE,qCAAA;EACA,yCAAA;EACA,yDAAA;EACA,yBAAA;AAVN;AAaI;EAEE,qCAAA;EACA,8CAAA;AAZN;AAgBE;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,WAAA;EACA,eAAA;AAdJ;AAgBI;EACE,WAAA;EACA,sBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,2CAAA;EACA,uCAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AAdN;;AAoBE;EACE,0BAAA;AAjBJ;;AAuBI;EACE,0BAAA;AApBN","sourcesContent":[".checkbox {\n  --main-color: var(--blue);\n  --border-color: var(--blue-grey-300);\n  --bg-color: var(--grey-100);\n  display: flex;\n  align-items: center;\n  position: relative;\n\n  &-yellow {\n    --main-color: var(--yellow);\n    --border-color: var(--yellow);\n    --bg-color: var(--yellow);\n  }\n\n  &-brown {\n    --main-color: var(--brown);\n    --border-color: var(--brown);\n    --bg-color: var(--brown);\n  }\n\n  &-red {\n    --main-color: var(--red-300);\n    --border-color: var(--red-300);\n    --bg-color: var(--red-300);\n  }\n\n  &-orange {\n    --main-color: var(--orange-200);\n    --border-color: var(--orange-200);\n    --bg-color: var(--orange-200);\n  }\n\n  &-green {\n    --main-color: var(--green);\n    --border-color: var(--green);\n    --bg-color: var(--green);\n  }\n\n  &-blue {\n    --main-color: var(--blue-200);\n    --border-color: var(--blue-200);\n    --bg-color: var(--blue-200);\n  }\n\n  &-violet {\n    --main-color: var(--violet);\n    --border-color: var(--violet);\n    --bg-color: var(--violet);\n  }\n\n  &-grey {\n    --main-color: var(--grey-500);\n    --border-color: var(--grey-500);\n    --bg-color: var(--grey-500);\n  }\n\n  &-white {\n    --main-color: var(--white);\n    --bg-color: var(--white);\n\n    .checkbox__field:checked + .checkbox__label:before {\n      border-color: rgba(var(--blue-grey-300));\n      background-image: url('../../../../public/check-black.svg');\n    }\n  }\n\n  &-black {\n    --main-color: var(--black);\n    --border-color: var(--black);\n    --bg-color: var(--black);\n  }\n\n  &__field {\n    position: absolute;\n    z-index: -1;\n    opacity: 0;\n\n    &:checked + .checkbox__label:before {\n      border-color: rgba(var(--main-color));\n      background-color: rgba(var(--main-color));\n      background-image: url('../../../../public/check.svg');\n      background-size: 11px 9px;\n    }\n\n    &:focus:not(:checked):not(.checkbox__field_custom-color)\n      + .checkbox__label:before {\n      border-color: rgba(var(--main-color));\n      background-color: rgba(var(--main-color), 0.1);\n    }\n  }\n\n  &__label {\n    display: inline-flex;\n    align-items: center;\n    user-select: none;\n    width: 100%;\n    cursor: pointer;\n\n    &:before {\n      content: '';\n      box-sizing: border-box;\n      display: inline-block;\n      width: 1.25rem;\n      height: 1.25rem;\n      flex-shrink: 0;\n      flex-grow: 0;\n      border: 1px solid rgba(var(--border-color));\n      background-color: rgba(var(--bg-color));\n      border-radius: 0.25rem;\n      margin-right: 0.5rem;\n      background-repeat: no-repeat;\n      background-position: center center;\n      background-size: 50% 50%;\n    }\n  }\n}\n\n.filter__brand-list {\n  .checkbox__label {\n    text-transform: capitalize;\n  }\n}\n\n[data-filter='brand'] {\n  .dropdown_mobile {\n    .checkbox__label {\n      text-transform: capitalize;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
